document.addEventListener("DOMContentLoaded", function () {
  const dataEl = document.getElementById("ProductFormData");
  if (!dataEl) return;

  const { variants, numOptions, defaultVariantId, moneyFormat } = JSON.parse(dataEl.textContent);
  const variantInput = document.getElementById("SelectedVariantId");

  function getVariantIdFromURL() {
    const params = new URLSearchParams(window.location.search);
    return params.get("variant");
  }

  function getSelectedOptions() {
    const selected = [];
    for (let i = 0; i < numOptions; i++) {
      const checked = document.querySelector(`input[name="option-${i}"]:checked`);
      selected.push(checked ? checked.value : null);
    }
    return selected;
  }

  function findMatchingVariant(options) {
    return variants.find(v =>
      v.options.every((opt, i) => opt === options[i])
    );
  }

    function updateVariant() {
      const currentOptions = getSelectedOptions();
      const match = findMatchingVariant(currentOptions);
      if (match) {
        variantInput.value = match.id;
  
        const fixedVariantInput = document.querySelector('.fixed-variant-id');
        if (fixedVariantInput) {
          fixedVariantInput.value = match.id;
        }
      
        const priceEl = document.querySelector('.price-value');
        const compareEl = document.querySelector('.product-compare-price');
        const savingsBox = document.querySelector('.savings_box');
      
        if (priceEl) {
          priceEl.textContent = Shopify.formatMoney(match.price, moneyFormat).replace('.00', '');
        }
      
        if (compareEl) {
          if (match.compare_at_price > match.price) {
            compareEl.textContent = Shopify.formatMoney(match.compare_at_price, moneyFormat).replace('.00', '');
            compareEl.style.display = 'inline';
          } else {
            compareEl.style.display = 'none';
          }
        }
      
        if (savingsBox) {
          if (match.compare_at_price > match.price) {
            const savings = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
            savingsBox.textContent = `${savings}% off sale`;
            savingsBox.style.display = 'inline-block';
          } else {
            savingsBox.style.display = 'none';
          }
        }

        const preorderBtn = document.querySelector('.preorder_button');
        if (preorderBtn) {
          if (match.inventory_policy === 'continue') {
            preorderBtn.style.display = 'inline-block';
        
            const span1 = preorderBtn.querySelector('.preorder_text');
            const span2 = preorderBtn.querySelector('.preorder_subtext');
        
            if (span1) {
              const compare = match.compare_at_price > match.price
                ? `<s>${Shopify.formatMoney(match.compare_at_price, moneyFormat).replace('.00', '')}</s> `
                : '';
              span1.innerHTML = `Add Pre-order - ${compare}${Shopify.formatMoney(match.price, moneyFormat).replace('.00', '')}`;
            }
        
            if (span2) {
              span2.innerHTML = (match.compare_at_price > match.price ? `Wait & Save:` : '') + ` Estimated to Ship Aug 14`;
            }
        
          } else {
            preorderBtn.style.display = 'none';
          }
        }
  
        // Handle notify button visibility and insertion
        const notifyWrapper = document.querySelector('.product_form_unavailable .product_add');
        const existingNotifyBtn = notifyWrapper?.querySelector('.notify_button');
        
        // Remove notify button if no form_id
        if (match.form_id) {
          if (!existingNotifyBtn) {
            const btn = document.createElement('button');
            btn.setAttribute('type', 'button');
            btn.className = 'notify_button';
            btn.innerHTML = '<span>Notify When Available</span>';
            notifyWrapper?.appendChild(btn);
          }
        } else if (existingNotifyBtn) {
          existingNotifyBtn.remove();
        }
  
        const fixedNotifyBtn = document.querySelector('.notify_button.fixed_form_unavailable');
        if (fixedNotifyBtn) {
          const span = fixedNotifyBtn.querySelector('span');
          if (match.form_id) {
            span.textContent = `Notify When Available`;
            fixedNotifyBtn.style.background = '';
            fixedNotifyBtn.style.color = '';
          } else {
            span.textContent = `Sold Out`;
            fixedNotifyBtn.style.background = '#999';
            fixedNotifyBtn.style.color = '#d9d9d9';
          }
        }
  
        const priceWrapper = document.querySelector('.product-price');
        if (priceWrapper) {
          priceWrapper.classList.toggle('on-sale', match.compare_at_price > match.price);
        }
      
        const newUrl = `${window.location.pathname}?variant=${match.id}`;
        window.history.replaceState({ path: newUrl }, '', newUrl);
  
        const formPairs = [
          ['.product_form_available', '.product_form_unavailable'],
          ['.fixed_form_available', '.fixed_form_unavailable']
        ];
        
        formPairs.forEach(([availableSelector, unavailableSelector]) => {
          const availableForm = document.querySelector(availableSelector);
          const unavailableForm = document.querySelector(unavailableSelector);
        
          if (availableForm && unavailableForm) {
            if (match.inventory_quantity > 0) {
              availableForm.style.display = '';
              unavailableForm.style.display = 'none';
            } else {
              availableForm.style.display = 'none';
              unavailableForm.style.display = '';
            }
          }
        });

        // Toggle delivery estimate visibility
        const deliverySpan = document.querySelector('delivery-date')?.closest('span');
        if (deliverySpan) {
          deliverySpan.style.display = match.inventory_quantity > 0 ? '' : 'none';
        }
  
        /*
  
        const availableForm = document.querySelector('.product_form_available');
        const unavailableForm = document.querySelector('.product_form_unavailable');
      
        if (availableForm && unavailableForm) {
          if (match.inventory_quantity > 0) {
            availableForm.style.display = '';
            unavailableForm.style.display = 'none';
          } else {
            availableForm.style.display = 'none';
            unavailableForm.style.display = '';
          }
        }
  
        const availableFormFixed = document.querySelector('.fixed_form_available');
        const unavailableFormFixed = document.querySelector('.fixed_form_unavailable');
      
        if (availableFormFixed && unavailableFormFixed) {
          if (match.inventory_quantity > 0) {
            availableFormFixed.style.display = '';
            unavailableFormFixed.style.display = 'none';
          } else {
            availableFormFixed.style.display = 'none';
            unavailableFormFixed.style.display = '';
          }
        }
  
        */
  
        const notifyBtns = document.querySelectorAll('.notify_button');
        const preselectedId = document.getElementById('preSelectedVariantId')?.value;
        
        if (match.form_id && match.id.toString() !== preselectedId) {
          notifyBtns.forEach((btn) => {
            btn.onclick = function () {
              window._klOnsite = window._klOnsite || [];
              window._klOnsite.push(['openForm', match.form_id]);
            };
          });
        }
  
        /*
        
        const notifyBtn = document.querySelector('.notify_button');
        const preselectedId = document.getElementById('preSelectedVariantId')?.value;
        
        if (notifyBtn && match.form_id && match.id.toString() !== preselectedId) {
          notifyBtn.onclick = function () {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', match.form_id]);
          };
        }
  
        */
        
      } else {
        variantInput.value = "";
      }
    }

    function updateFixedNotifyButton(match) {
      const fixedNotifyBtn = document.querySelector('.notify_button.fixed_form_unavailable');
      if (fixedNotifyBtn) {
        const span = fixedNotifyBtn.querySelector('span');
        if (match.form_id) {
          span.textContent = `Notify When Available`;
          fixedNotifyBtn.style.background = '';
          fixedNotifyBtn.style.color = '';
        } else {
          span.textContent = `Sold Out`;
          fixedNotifyBtn.style.background = '#999';
          fixedNotifyBtn.style.color = '#d9d9d9';
        }
      }
    }


  // Quantity controls
  document.addEventListener('click', function (e) {
    if (e.target.closest('.button-plus')) {
      const input = e.target.closest('.input-group').querySelector('.quantity-field');
      let val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    }

    if (e.target.closest('.button-minus')) {
      const input = e.target.closest('.input-group').querySelector('.quantity-field');
      let val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    }
  });

  // Variant setup on load
  setTimeout(function () {
  const variantIdFromURL = getVariantIdFromURL();
  
  if (variantIdFromURL) {
    let matchedVariant = variants.find(v => v.id == variantIdFromURL);
  
    // Skip USA-only variants (if they were excluded from rendering)
    if (matchedVariant && matchedVariant.options && matchedVariant.id) {
      matchedVariant.options.forEach((opt, i) => {
        const radio = document.querySelector(`input[name="option-${i}"][value="${opt}"]`);
        if (radio) radio.checked = true;
      });
  
      variantInput.value = matchedVariant.id;
  
      if (parseInt(variantIdFromURL) !== defaultVariantId) {
        updateVariant();
      }
    } else {
      // Fallback if excluded
      const fallbackVariant = variants[0];
      if (fallbackVariant) {
        fallbackVariant.options.forEach((opt, i) => {
          const radio = document.querySelector(`input[name="option-${i}"][value="${opt}"]`);
          if (radio) radio.checked = true;
        });
  
        variantInput.value = fallbackVariant.id;
        updateVariant();
      }
    }
  } else {
    variantInput.value = defaultVariantId;
  }
  
    document.querySelectorAll('[name^="option-"]').forEach(input => {
      input.addEventListener("change", updateVariant);
    });
  }, 0);
});